import { render, staticRenderFns } from "./AllotteesCebuBoholBicolcdoDavaoMm2021.vue?vue&type=template&id=3b975a0a&scoped=true"
import script from "./AllotteesCebuBoholBicolcdoDavaoMm2021.vue?vue&type=script&lang=js"
export * from "./AllotteesCebuBoholBicolcdoDavaoMm2021.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b975a0a",
  null
  
)

export default component.exports